import { Routes } from '@angular/router';
import { PACKAGEGOODS_CONFIGS } from './base/packagegoods-configs';
import { createPackagegoodsRoute } from './base/packagegoods-route.factory';
import { PackagegoodsKey } from './base/packagegoods.types';

/**
 * Packagegoods 통합 라우팅 (Config-Driven)
 *
 * AS-IS: 1개 Modern + 3개 Legacy 별도 라우팅
 * TO-BE: 4개 타입을 Config-Driven으로 통합
 *
 * - packagegoods: 메인 패키지 (5탭)
 * - car: 차량 패키지 (3탭: basic, schedule, media)
 * - guide: 가이드 패키지 (3탭: basic, schedule, media)
 * - requests: 요청 패키지 (5탭)
 */
export const packagegoodsRoutes: Routes = (
  ['packagegoods'] as PackagegoodsKey[]
).map((key) => createPackagegoodsRoute(key, PACKAGEGOODS_CONFIGS[key]));
